import Button from '@creditflowresearch/uilib/Button';

import styles from './loadMore.module.scss';

interface ILoadMoreProps {
  collection: unknown[] | null,
  totalCount: number | null,
  loadMore: () => void,
  disabled?: boolean,
}

const LoadMore = ({
  collection,
  totalCount,
  loadMore,
  disabled = false,
}: ILoadMoreProps) => {
  if (!collection || !totalCount || collection.length >= totalCount || (collection.length === 0 && totalCount === 0)) {
    return null;
  }

  return (
    <Button
      dataTest="dealsListLoadMoreButton"
      onClick={ loadMore }
      className={ styles.moreBtn }
      variant="text"
      disabled={ disabled }
    >
      More
    </Button>
  );
};

export default LoadMore;
